
    <button class="back-button" type="button" (click)="back('/rec-plan-name-result-pg')">
      Back
    </button>


<dx-report-viewer [reportUrl]="reportUrl" height="800px">
  <dxrv-request-options [invokeAction]="invokeAction" [host]="hostUrl"></dxrv-request-options>
          <!--<dxrv-callbacks (CustomizeMenuActions)="CustomizeMenuActions($event)" (CustomizeExportOptions)="CustomizeExportOptions($event)">
        </dxrv-callbacks>-->
</dx-report-viewer>
